<template>
  <div>
  <div style="color: red;font-weight: 600;display: flex;align-items: center;background-color: white;padding: 12px;">
    系统通知：每天中午12点30分至1点30分和夜间10点至10点30分期间为系统升级维护时间，如遇到无法使用的情况请稍等几分钟，按一下键盘上方的“F5”进行系统更新然后再次使用。
  </div>
  <PdfViewer url="/static/瑞家园管理系统操作手册(公司端).pdf" :height="pageHeight"
             v-if="hasRole($const.roleKeys.Business)||hasRole($const.roleKeys.CompanyAdmin)||hasRole($const.roleKeys.FINANCE)"></PdfViewer>
  <div v-else-if="hasRole($const.roleKeys.Company)">
    <FactoryPage></FactoryPage>
  </div>
  </div>
</template>

<script>
import FactoryPage from './factory/index.vue'
import PdfViewer from '@/components/PdfViewer'

export default {
  components: {
    PdfViewer, FactoryPage
  },
  data () {
    return {
      pageHeight: 500
    }
  },
  activated () {
    this.pageHeight = document.body.clientHeight - 50
  },

  methods: {
    hasRole (roleKey) {
      let currentUser = this.$store.state.user
      if (currentUser.roleIdList.find(r => r === roleKey)) {
        return true
      }
    },
    getData () {
    },
  }
}
</script>

<style lang="scss" scoped>
.report-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .report-item {
    width: calc(100% / 5);
    min-width: 190px;
    height: 100px;
    display: flex;
    flex: none;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .name {
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
